import { GA4Event } from "./GA4Event";

export function buildBrazeIamViewEvent(model) {
	const { trigger_id } = model.attributes;
	const { eventData } = new GA4Event("braze-in-app-message-view", {
		trigger_id: trigger_id || ""	});
	return eventData;
}
